import React from 'react';
/*ui*/
import Typography from "@material-ui/core/Typography";
/*component*/
import toLocale from "../../../helpers/toLocale";

const searchCarPrice = (carData, classes) => {
    if (!carData.total_price_with_vat) return;

    if (!carData.final_offer_price_with_vat) {
        return (
            <React.Fragment>
                <div>{toLocale(carData.total_price_with_vat)}€ <span className={classes.tva}>TVA <br />inclus</span></div>
            </React.Fragment>
        )
    } else {
        return (
            <React.Fragment>
                <div>{toLocale(carData.final_offer_price_with_vat)}€ <span className={classes.tva}>TVA <br />inclus</span>
                    <Typography variant="caption"
                        className={classes.oldPrice}>{toLocale(carData.total_price_with_vat)}€</Typography> <span className={classes.tva}>TVA <br />inclus</span></div>
            </React.Fragment>
        )
    }
}

export default searchCarPrice;
